import Fingerprint2 from 'fingerprintjs2'
import store from '../store'
import * as types from '../store/types'

var MobileDetect = require('mobile-detect');

var point = {
  // surl: "http://47.112.42.39:7091/point/send",
  surl: " https://www.haoyunba.com/point/send",
  ptype: {
    load: "C_LOAD",
    forwad: "C_FORWARD",
    event: "C_EVENT",
    net: "C_NET"
  },

  appinfo: {
    appid: "1001",
    appver: "V1.0.1",
    source: "3",
    cid: " "
  },

  devi: {
    brand: " ",
    modx: " ",
    did: " ",
    sver: " "
  },

  formatTm: function (date) {
    var date = new Date(date);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();

    month = (month < 10 ? "0" : "") + month;
    day = (day < 10 ? "0" : "") + day;
    hour = (hour < 10 ? "0" : "") + hour;
    minute = (minute < 10 ? "0" : "") + minute;
    second = (second < 10 ? "0" : "") + second;

    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' +
      second;
  },

  copy: function (old, newo) {
    for (var index in old) {
      newo[index] = old[index];
    }
  },

  initreq: function (datas, ctype) {
    this.copy(this.appinfo, datas);
    this.copy(this.devi, datas);
    // this.copy(point, datas);

    //
    var endtime = new Date();
    datas.pg = window.location.href;
    datas.atx = ctype;
    datas.dt = this.formatTm(endtime);
    if (store.state.mutations.user) {
      datas.cid = store.state.mutations.channel;
    } else {
      datas.cid = 'Y000014'
    }

    if (store.state.mutations.channel) {
      datas.cid = store.state.mutations.channel;
    } else {
      datas.cid = 'Y000014'
    }

    console.log("产品id：" + store.state.mutations.pid)
    if (store.state.mutations.pid) {
      datas.appid = store.state.mutations.pid;
    } else {
      datas.appid = 1001;
    }


    if (ctype == this.ptype.load) {
      datas.timex = endtime - point_start_time;
    }
  },

  req: function (ctype, tag, eid, bid, res, err) {
    var da = this;
    var datas = {};
    datas.tag = tag;
    datas.eid = eid;
    datas.bid = bid;
    datas.res = res;
    datas.err = err;

    this.initreq(datas, ctype)

    $.ajax({
      url: da.surl,
      data: datas,
      type: "POST",
      dataType: "json",
      success: function (data) {}
    });
  },

  even: function (obj) {
    this.req(this.ptype.event, " ", obj.id, "", "1", "");
  },

  eventId: function (id) {
    this.req(this.ptype.event, " ", id, "", "1", "");
  },
  eventuid: function (id,uid,bid) {
    this.req(this.ptype.event, uid, id, bid, "1", "");
  },


  load: function () {
    this.req(this.ptype.load, " ", "", "", "1", "");
  },

  foward: function (tag) {
    this.req(this.ptype.forwad, tag, "", "", "1", "");
  },

  event: function (ctype, tag, eid, bid, res, err) {
    this.req(ctype, tag, eid, bid, res, err);
  },

  eventtag: function (id,tag) {
    this.req(this.ptype.event, tag, id, "", "1", "");
  },

  init: function (time) {
    var d = this;
    //console.log('加载时间'+time);
    if (time != null && time != undefined) {
      //console.log('加载时间'+time);
      point_start_time = time;
    }


    Fingerprint2.get(function (components) {
      var murmur = Fingerprint2.x64hash128(components.map(function (pair) {
        return pair.value
      }).join(), 31);

      var details = ""
      for (var index in components) {
        var obj = components[index]
        var line = obj.key + " = " + String(obj.value).substr(0, 100)
        details += line + "\n"
      }

      var mobile = d.getMoblie();

      $("#msgx").val(
        mobile.os + "\n" + "\n" + mobile.model + "\n" + "\n" +
        murmur + "\n" + "\n" + details);

      d.devi.brand = mobile.brand;
      d.devi.modx = mobile.model;
      d.devi.did = murmur;
      d.devi.sver = mobile.os;
      d.appinfo.source = d.appinfo.source + mobile.ostag;

      d.load();

    });
  },

  getMoblie: function () {


    var user_agent = navigator.userAgent;
    console.log(user_agent);
    // 初始化mobile-detect
    var md = new MobileDetect(user_agent);
    var os = md.os(); // 获取系统
    var newMobile = "";
    var oss = 0
    var brand = "";
    // ios系统的处理
    if (os == "iOS") {
      brand = "iPhone";
      os = md.os() + " " + md.version("iPhone");
      //ios = md.mobile();
      try {
        // 再通过iphone-device.js获取具体的苹果手机型号
        newMobile = MobileDevice.getModels().join(' or ');
        if (newMobile == 'unknown') {
          newMobile = '';
        }
      } catch (e) {
        newMobile = "iPhone";
      }
      oss = 1
    }
    // Android系统的处理
    else if (os == "AndroidOS") {
      os = md.os() + " " + md.version("Android");
      var sss = user_agent.split(";");
      // 判断UA里边有没有Build信息，通过这个拿到安卓的具体机型
      for (var i = 0; i < sss.length; i++) {
        if (sss[i].includes("Build/")) {
          newMobile = sss[i].substring(0, sss[i].indexOf("Build/"));
          break;
        }
      }
      oss = 2
    }
    return {
      "brand": brand,
      "ostag": oss,
      "os": os,
      model: newMobile
    };
  },

};

var point_start_time = new Date();

export default point



// WEBPACK FOOTER //
// ./src/point/point.js